import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { header, actions, content, title } from './header.css.js';

function Header({ children, className, ...rest }) {
  const classes = clsx(header, className);
  return /* @__PURE__ */ jsx("header", { className: classes, ...rest, children });
}
function Title({ children, className, ...rest }) {
  const classes = clsx(title, className);
  return /* @__PURE__ */ jsx("section", { className: classes, ...rest, children });
}
function Content({ children, className, ...rest }) {
  return /* @__PURE__ */ jsx("section", { className: clsx(content, className), ...rest, children });
}
function Actions({ children, className, ...rest }) {
  return /* @__PURE__ */ jsx("section", { className: clsx(actions, className), ...rest, children });
}

export { Actions, Content, Header, Title, Header as default };
